export function formatCycle(cycle: string) {
  switch (cycle) {
    case 'Cycle 1':
      return 'cycle1';
    case 'Cycle 2':
      return 'cycle2';
    case 'Cycle 3':
      return 'cycle3';
    case 'Cycle 4':
      return 'cycle4';
    default:
      return cycle;
  }
}
